import axios from 'axios';

export const DEV_AUTH_TOKEN_KEY = 'radgrind_dev_auth_token';

const instance = axios.create({
    baseURL: process.env.VUE_APP_API,
    withCredentials: true,
    timeout: 5000, // set the default timeout for requests to 5 seconds
});

if (process.env.NODE_ENV !== 'production') {
    const token = localStorage.getItem(DEV_AUTH_TOKEN_KEY);
    if (token) {
        instance.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
}

instance.interceptors.request.use(function (config) {
    let currency = localStorage.getItem('currency');
    if (!currency) {
        currency = 'EUR'
    }
    if (config.method === 'get') {
        config.params = {
            ...config.params,
            currency
        }

    } else if(['post', 'put', 'patch', 'POST', 'PUT', 'PATCH'].includes(config.method)) {
        config.data = {
            ...config.data,
            currency
        }
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default instance;
